import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';

const RequestImageWall = ({ fileList, setFileList, uploadImage, setuploadImage }) => {
  //   const [previewOpen, setPreviewOpen] = useState(false);
  //   const [previewImage, setPreviewImage] = useState("");

  // const handleChange = ({ fileList: newFileList }) => {
  //   setFileList(newFileList);
  //   console.log(newFileList);
  // };

  

  let headers = getHeaders();
  const handleuploadImage = ({ fileList: newFileList, file }) => {
    console.log(file)
 
    console.log('New File List', newFileList);
    // console.log("file", file)
    // if (info.file.status === "uploading") {
    //   setimageuploading(true);
    // }
    setFileList(newFileList);
 
    if (file.status === 'done') {
      // Get this url from response in real world.
      if (file) {
        console.log('Upload image inside file', file?.response?.result?.data?.Location);
        let images = uploadImage;
        images.push(file?.response?.result?.data?.Location);
        console.log("Images", images)
        setuploadImage(images);
        // setImageUploadError('');
      }
    }
    if (file.status === 'removed') {
      const updatedImages = uploadImage.filter((img) => img !== file.thumbUrl && img !== file?.response?.result?.data?.Location);
      setuploadImage(updatedImages);
    }
   
  };


  const uploadButton = (
    <div
      // style={{
      //   border: 0,
      //   background: 'none',
      //   color: 'black',
      //   backgroundColor:"#fff"
      // }}
      // type='button'
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  return (
    <div className='p-3'>
      <Upload
        action={`${app.URL}/api/v1/general/banner/imageupload`}
        headers={headers}
        listType='picture-card'
        fileList={fileList}
        // onPreview={handlePreview}
        onChange={handleuploadImage}
      >
        {uploadButton}
        {/* {fileList.length === 4 ? null : uploadButton} */}
      </Upload>
      {/* {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )} */}
    </div>
  );
};
export default RequestImageWall;
